import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import './i18n';
import './index.css';

ReactDOM.render(<App />, document.getElementById('root'));
